/** Idade em anos a partir da data de nascimento. `STK-11` — função pura, em `utils/`. */
export function calcularIdade(dataNascimento?: Date | string | null): number | null {
  if (!dataNascimento) {
    return null;
  }

  const nascimento = new Date(dataNascimento);

  // Verifica se a data é válida
  if (isNaN(nascimento.getTime())) {
    return null;
  }

  const hoje = new Date();
  let idade = hoje.getFullYear() - nascimento.getFullYear();

  const mesAtual = hoje.getMonth();
  const diaAtual = hoje.getDate();
  const mesNascimento = nascimento.getMonth();
  const diaNascimento = nascimento.getDate();

  if (
    mesAtual < mesNascimento ||
    (mesAtual === mesNascimento && diaAtual < diaNascimento)
  ) {
    idade--;
  }

  return idade;
}
